import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { likePost } from "../../features/like/likeSlice";
import { fetchPost } from "../../features/post/postSlice";
import { savePost } from "../../features/saved/savedSlice";

const DetailedPost = ({ post }) => {
  const { id, title, description, tags, likes, isSaved, image, createdAt } =
    post;

  const dispatch = useDispatch();

  const handleLike = () => {
    // e.preventDefault();
    dispatch(likePost({ id, likes }));
    dispatch(fetchPost(id));
  };

  const handleSaved = () => {
    dispatch(savePost({ id, isSaved }));
    dispatch(fetchPost(id));
  };
  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tags?.map((tag, i) => (
            <span key={i}>#{tag}, </span>
          ))}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={handleLike}
          >
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" className and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button
            className={`${isSaved && "active"} save-btn`}
            id="lws-singleSavedBtn"
            onClick={handleSaved}
          >
            <i className="fa-regular fa-bookmark"></i> Saved
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
};

export default DetailedPost;
